module.exports = __webpack_public_path__ + "img/submit-hover.d638115e.png";